import React from "react";
import classNames from "classnames";

import matt from "../assets/images/matt.jpeg";
import naomi from "../assets/images/naomi.jpeg";
import richard from "../assets/images/richard.jpeg";
import ben from "../assets/images/ben.jpeg";
import none from "../assets/images/none.png";

import { makeStyles } from "@material-ui/core/styles";
import { Grid, Card } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  item: {
    margin: theme.spacing(2.75),
  },
  cardSpacing: {
    padding: theme.spacing(0.75),
  },
  photoHolder: {
    boxShadow: "None",
    backgroundColor: "transparent",
  },
  photo: {
    borderRadius: "50px",
    height: "300px",
    backgroundColor: "#c6385e",
    "@media screen and (max-width: 700px)": {
      height: "200px",
      borderRadius: "25px",
    },
    "@media screen and (max-width: 500px)": {
      height: "100px",
      borderRadius: "10px",
    },
  },
}));

function Organisers() {
  const classes = useStyles();
  const images = [
    ["Richard Clegg (QMUL)", richard],
    ["Naomi Arnold (QMUL)", naomi],
    ["Nicola Perra (QMUL)", ""],
    ["Matt Barnes (QMUL)", matt],
    ["Ben Steer (Pometry)", ben],
  ];

  return (
    <Grid container className={classes.root}>
      {images.map((image) => (
        <Grid item xs className={classes.item}>
          <Card
            key={image[0]}
            className={classNames(classes.cardSpacing, classes.photoHolder)}
          >
            {image[1] ? (
              <img
                className={classes.photo}
                src={image[1]}
                alt={image[0]}
                title={image[0]}
              />
            ) : (
              <img className={classes.photo} src={none} alt={"none"} />
            )}
            <p>
              <strong>{image[0]}</strong>
            </p>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}

export default Organisers;
